import type { Accept } from 'react-dropzone'

const extensionLabels = (accept: Accept) =>
  Object.values(accept)
    .flat()
    .map((extension) => extension.replace(/^\./, '').toUpperCase())

const formatLimitsPerFile = (maxSize?: number, maxPages?: number) => {
  const limits = [
    maxSize ? `${maxSize} MB` : null,
    maxPages !== undefined ? `${maxPages} pages` : null,
  ].filter((limit) => limit !== null)
  return limits.length > 0 ? `up to ${limits.join(' and ')} per file` : null
}

export const formatDropzoneHint = (
  accept?: Accept,
  maxSize?: number,
  maxPages?: number,
) => {
  const parts: string[] = []
  const labels = accept ? extensionLabels(accept) : []
  if (labels.length > 0) {
    const suffix = labels.length === 1 ? ' only' : ''
    parts.push(`${labels.join(', ')}${suffix}`)
  }
  const limits = formatLimitsPerFile(maxSize, maxPages)
  if (limits) parts.push(limits)
  return parts.join(' · ')
}

export const formatTypeRestriction = (accept?: Accept) => {
  const labels = accept ? extensionLabels(accept) : []
  return labels.length > 0
    ? `Only ${labels.join(', ')} files are allowed`
    : 'This file type is not allowed'
}
